<template>

  <a-select :show-search='showSearch'
          :allowClear='allowClear'
          :filter-option='filterOption'
          :placeholder="placeholder"
          :disabled="disabled"
          :value="value"
          :getPopupContainer="getPopupContainer"
          @change="handleInput">
      <a-select-option v-for='(v,k) in dataSource' :key='k' :value='k' :label='v'>
        {{ v }}
      </a-select-option>
  </a-select>




</template>

<script>

  export default {
    name: "FSelectDict",
    props: {
      placeholder: String,
      disabled: Boolean,
      showSearch:{
        type:Boolean,
        required: false,
        default: false,
      },
      filterOption:{
        type:Function,
        required: false,
        default: (input, option)=>option.componentOptions.propsData.label.toLocaleString().indexOf(input.toLocaleString())>=0,
      },
      value: [String, Number],
      allowClear:Boolean,
      getPopupContainer:{
        type: Function,
        default: () => document.body
      },
      dataSource:{
        type: Object,
        required:true,
        default: () => {}
      }
    },
    data() {
      return {
      }
    },
    watch:{
    },
    created() {
        console.log("dataSource:",this.dataSource)
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      handleInput(e='') {
        let val;
        if(Object.keys(e).includes('target')){
          val = e.target.value
        }else{
          val = e
        }
        this.$emit('change', val);
      },
    },
    model:{
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style scoped>
</style>